export {};
//# sourceMappingURL=initializeMultisig2.js.map